/**
 * Show a placeholder image when the image is not present on the server
 *
 * @example <img ng-src="{{URL}}" tmr-on-error="{{placeholderImage}}" >
 *
 * @namespace
 * @alias tmrOnError
 * @type {ngDirective}
 */
let tmrOnErrorDirective = /*@ngInject*/ () => ({
  link: (scope, element, attribute) =>
    element.on('error', () => {
      element.attr('src', attribute.tmrOnError)
    }),
  restrict: 'A',
})

export const directive = ['tmrOnError', tmrOnErrorDirective]
